module.exports = __webpack_public_path__ + "static/improves-2bfef08c2827beae7e5f7c94c7d64e17.svg";